import { useEffect, useMemo } from "react"

import { useTenantSettings } from "stores/tenantSettings"

export default function useTenantWarehouseOptions(init?: boolean) {
    const {
        tenantWarehouses,
        fetchTenantWarehouses,
    } = useTenantSettings()

    const tenantWarehouseOptions = useMemo(() => {
        return tenantWarehouses?.entities.map(w => ({ label: w.description, value: w.id }))
    }, [tenantWarehouses])

    useEffect(() => {
        if (!tenantWarehouses && init) {
            fetchTenantWarehouses()
        }
    }, [init, fetchTenantWarehouses, tenantWarehouses])

    return {
        tenantWarehouseOptions,
        noWarehouseId: tenantWarehouses && !tenantWarehouses.isNoWarehouseIdEmpty ? tenantWarehouses.noWarehouseId : undefined,
    }

}
